import { render, staticRenderFns } from "./CalendarExport.vue?vue&type=template&id=3dff0a8c&scoped=true&"
import script from "./CalendarExport.vue?vue&type=script&lang=ts&"
export * from "./CalendarExport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dff0a8c",
  null
  
)

export default component.exports